import { rtkApi } from 'app/store/AppStore.rtk'
import { apiDistrUrl } from 'features/Env'
import { DistrictListResponse, SportListRequest, SportListResponse, State } from 'types'

export const initApi = rtkApi
  .enhanceEndpoints({
    addTagTypes: ['state', 'districts', 'sports', 'backgroundImage'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getStateById: build.query<State, string>({
        query: (stateId) => `/states/${stateId}`,
        providesTags: ['state'],
      }),

      getDistricts: build.query<DistrictListResponse, string>({
        query: (stateId) => {
          return {
            url: `/districts`,
            params: {
              stateId,
              isActive: true,
              page: 1,
              perPage: 500,
            },
          }
        },
        providesTags: ['districts'],
      }),

      getSports: build.query<SportListResponse, SportListRequest>({
        query: ({ stateId, districtId }) => {
          return {
            url: `/sports`,
            params: {
              stateId,
              districtId,
              page: 1,
              perPage: 500,
            },
          }
        },
        providesTags: ['sports'],
      }),

      getBackgroundImage: build.query<{ url: string }, string>({
        query: (imageId) => ({
          url: `${apiDistrUrl}/api/csz/distribution/images/${imageId}`,
        }),
        providesTags: ['backgroundImage'],
      }),
    }),
  })

export const {
  useGetStateByIdQuery,
  useGetDistrictsQuery,
  useGetSportsQuery,
  useGetBackgroundImageQuery,
} = initApi
